import React  from 'react'


import { Row , Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmarkCircle , faFileInvoice } from '@fortawesome/free-solid-svg-icons'

function FormHeader( {close}) {

    function onClose()
    {
        close() ;
    }
  return (
    <>

        <Row >
            <Col className='col-11'>
                <div style={{display:'flex'}} >
                    <FontAwesomeIcon icon={faFileInvoice} style={{color:'grey' , height:20 , paddingTop:'5px'}}/>
                    <p style={{fontSize:'20px' , paddingLeft : '5px' , marginBottom : '2px'}}>Catalogo de Cuentas</p>
                </div>
                
            </Col>
            {/* <Col className='col-4'/> */}
            
            <Col className='col-1'>
                <FontAwesomeIcon className='pt-2 ps-2' onClick={onClose} icon={faXmarkCircle} 
                title='Close' style={{color:'gray' , height:25 }}/>
            </Col>

        </Row>

    </>

  )
}

export default FormHeader